import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { LoginService } from '../services/login-service/login.service';
import { LOGIN_PAGES } from '../routes/login-process/enum-login-pages';

import { DialogService } from 'primeng/dynamicdialog';
import { LoginModalComponent } from 'src/app/components/login-modal/login-modal.component';
import { filterSelectionState } from '../routes/search-cars-component/search-cars.helper.consts';

@Injectable()
export class CanActivateGuard implements CanActivate {
  constructor(
    private router: Router,
    private loginService: LoginService,
    private dialogService: DialogService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const rslt = this.loginService.isSessionValid();
    const storedEmail = localStorage.getItem('userEmail');
    if (!rslt && !storedEmail) {
      this.router.navigate(['/']);
      this.loginService.setUser(null);
      /*this.dialogService.open(LoginModalComponent, {
        data: {
          step: LOGIN_PAGES.EMAIL,
        },
        width: '980px',
        closeOnEscape: false,
      });*/
      return false;
    } else if (route.queryParams['val'] !== undefined) {
      return this.decodeQueryParams(route);
    } else {
      return true;
    }
  }

  decodeQueryParams(route: any) {
    if (route.queryParams.val) {
      let val = this.decodeBase64(route.queryParams.val);
      val = JSON.parse(val);
      sessionStorage.setItem(filterSelectionState, JSON.stringify(val));
      this.router.navigate(['/search-inventory/search-cars']);
    } else {
      return true;
    }
    return true;
  }
  decodeBase64(encodedString: string): string {
    if (encodedString) {
      try {
        return atob(encodedString);
      } catch (error) {
        console.error('Error decoding Base64:', error);
        return '';
      }
    }
    return '';
  }
}
